import { Route, Routes } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { HomePage } from "@/pages/HomePage";
import { PricingPage } from "@/pages/PricingPage";
import { ProductOfficePage } from "@/pages/ProductOfficePage";
import { ProductFieldPage } from "@/pages/ProductFieldPage";
import { VerticalPage } from "@/pages/VerticalPage";
import { DemoPage } from "@/pages/DemoPage";
import { SignupPage } from "@/pages/SignupPage";
import { LegalTermsPage } from "@/pages/LegalTermsPage";
import { LegalPrivacyPage } from "@/pages/LegalPrivacyPage";
import { AboutPage } from "@/pages/AboutPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="product/office" element={<ProductOfficePage />} />
        <Route path="product/field" element={<ProductFieldPage />} />
        <Route path="verticals/:trade" element={<VerticalPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="demo" element={<DemoPage />} />
        <Route path="signup" element={<SignupPage />} />
        <Route path="legal/terms" element={<LegalTermsPage />} />
        <Route path="legal/privacy" element={<LegalPrivacyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
